import * as Yup from 'yup';
export const managerDetailsSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email format')
    .matches(/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
    .min(3, 'Minimum 3 characters')
    .max(50, 'Maximum 50 characters')
    .required('Email is required'),
  question: Yup.string()
    .required('Please enter a security question')
    .min(5, 'The question must be at least 5 characters')
    .max(40, 'The question must be no more than 40 characters')
    .matches(
      /^[A-Za-z0-9 .?!,]+$/,
      'Only letters, numbers, spaces, and punctuation (. ? ! ,) are allowed'
    )
    .test(
      'no-leading-trailing-spaces',
      'The question cannot start or end with a space',
      (value) => value === value?.trim()
    )
    .test(
      'not-only-numbers-spaces',
      'The question cannot consist of only numbers or spaces',
      (value) => !/^[\d\s]+$/.test(value ?? '')
    ),

  answer: Yup.string()
    .required('Please enter a security answer')
    .min(1, 'The answer must be at least 1 character')
    .max(25, 'The answer must be no more than 25 characters')
    .matches(
      /^[A-Za-z0-9]+$/,
      'Only letters and numbers are allowed, no spaces or special characters'
    ),
  fullName: Yup.string()
    .min(1, 'Minimum 1 character')
    .max(50, 'Maximum 50 characters')
    .required('Landlord or property manager name is required')
    .matches(
      /^(?=.*[a-zA-Z]).+$/,
      'Landlord or property manager name must contain at least one letter.'
    ),
});
